export const init = svgElement => {
  const url = svgElement.getAttribute('data-src');
  svgElement.classList.remove('js-inline-svg');
  const svgClassList = [...svgElement.classList];

  fetch(url)
    .then(response => response.text())
    .then(svg => {
      const svgContainer = document.createElement('div');
      svgContainer.innerHTML = svg;
      const el = svgContainer.querySelector('svg');
      el.classList.add(...svgClassList);

      if (!(el.hasAttribute('viewbox') || el.hasAttribute('viewBox'))) {
        const width = el.getAttribute('width');
        const height = el.getAttribute('height');
        el.setAttribute('viewBox', `0 0 ${width} ${height}`);
      }

      svgElement.parentNode.replaceChild(el, svgElement);
    })
    .catch(error => {
      console.error('Error loading SVG:', error);
    });
};
